export const BANKS_QUERY_KEY = 'banks';
